module.exports = __webpack_public_path__ + "static/img/05.ad58aef4.png";